<template>
  <div class="ia-result">
    <div class="ia-result-message">
      {{ TEXT.noResults }}
    </div>
    <div class="ia-result-suggestions-title">
      {{ TEXT.suggestionsTitle }}
    </div>
    <ul class="ia-result-suggestions-list">
      <li>{{ TEXT.suggestion1 }}</li>
      <li>{{ TEXT.suggestion2 }}</li>
      <li>{{ TEXT.suggestion3 }}</li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n-composable'
const { t } = useI18n()
const TEXT = {
  noResults: t('components.search_advance_ia.no_results_message'),
  suggestionsTitle: t('components.search_advance_ia.suggestions_title'),
  suggestion1: t('components.search_advance_ia.suggestion_1'),
  suggestion2: t('components.search_advance_ia.suggestion_2'),
  suggestion3: t('components.search_advance_ia.suggestion_3')
}
</script>

<style lang="scss" scoped>
.ia-result {
  font-family: $inter-font;
  width: 100%;
  padding: $spacing-xs;
  margin: 0px 10px;
  font-size: 1rem;
  display: flex;
  flex-direction: column;
  gap: 12px;
  box-sizing: border-box;
}

.ia-result-message {
  color: $neutral-grey-800;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
}

.ia-result-suggestions-title {
  color: $main-1000;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 26px;
}

.ia-result-suggestions-list {
  margin: 0;
  padding-left: 20px;
  color: $neutral-grey-800;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
}

.ia-result-suggestions-list li {
  margin-bottom: 4px;
  color: $neutral-grey-800;
}
</style>
